class PredictiveSearch {
  constructor() {
    this.input = document.querySelector('input[type="search"]');
    this.resultsContainer = document.getElementById('predictive-search-results');
    if (!this.input || !this.resultsContainer) return;

    this.input.addEventListener('input', this.handleInput.bind(this));
    this.input.setAttribute('autocomplete', 'off');
  }

  async handleInput(event) {
    const searchTerm = event.target.value.trim();

    if (searchTerm.length < 1) {
      this.resultsContainer.hidden = true;
      this.resultsContainer.innerHTML = '';
      return;
    }

    const url = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=5&section_id=predictive-search`;

    try {
      const res = await fetch(url);
      const data = await res.json();
      this.renderResults(data.resources.results.products);
    } catch (error) {
      console.error('Fehler bei Predictive Search:', error);
    }
  }

  renderResults(products) {
    if (!products || products.length === 0) {
      this.resultsContainer.innerHTML = '<p style="padding: 10px;">Keine Treffer</p>';
      this.resultsContainer.hidden = false;
      return;
    }

    const html = products.map(product => `
      <a href="${product.url}" style="display: flex; align-items: center; padding: 10px; text-decoration: none; border-bottom: 1px solid #eee;">
        <img src="${product.featured_image.url}" alt="${product.title}" style="width: 40px; height: 40px; object-fit: cover; margin-right: 10px;">
        <span>${product.title}</span>
      </a>
    `).join('');

    this.resultsContainer.innerHTML = html;
    this.resultsContainer.hidden = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PredictiveSearch();
});
